import { render } from "./FaqHeader.vue?vue&type=template&id=87a8890e&scoped=true"
const script = {}

import "./FaqHeader.vue?vue&type=style&index=0&id=87a8890e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87a8890e"]])

export default __exports__